import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import * as yup from 'yup';
import _ from '@lodash';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import jwtService from '../../auth/services/jwtService';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import moment from 'moment';
import { IconButton, InputAdornment, MenuItem, Typography } from '@mui/material';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Noah from '../admin/noah/Noah';
import { regions } from 'src/utils';
import PinCodeScreen from './SignInPin';
import { useThemeMediaQuery } from '@fuse/hooks';
import { Visibility, VisibilityOff } from '@mui/icons-material';

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  email: yup.string(),
  password: yup
    .string()
    .required('Please enter your password.')
    .min(4, 'Password is too short - must be at least 4 chars.'),
});

const defaultValues = {
  email: '',
  password: '',
  remember: true,
};


function SignInPage() {
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const { control, formState, handleSubmit, setError, setValue, getValues } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { t } = useTranslation('translate-language');
  const { isValid, dirtyFields, errors } = formState;
  const protocol = window.location.protocol;
  const dispatch = useDispatch();
  const [changelogin, setChangeLogin] = useState(false);
  const [registryLogin, setRegistryLogin] = useState(false);
  var info = localStorage.getItem("store_info")
  var decodedData = info ? JSON.parse(atob(info)) : {};
    const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const [changeUser, setChangeUser] = useState('');
  const [data, setData] = useState({
    'first_name': '',
    'last_name': '',
    "phone_number": "",
    "mail_address": "",
    "password": "",
    "role": "USER",
    "specialization_id": 0,
    "status": "ACTIVE",
    "photo": "",
    "company_name": "",
    "address": "",
    "chef_name": "",
    "photo_url": "",
    "city": ""

  });

  const CURRENT_VERSION = "1.0.10"; // har builddan keyin yangilang

  useEffect(() => {
    const savedVersion = localStorage.getItem("appVersion");

    if (savedVersion !== CURRENT_VERSION) {

      localStorage.setItem("appVersion", CURRENT_VERSION);

      // kuchli reload
      window.location.href = window.location.href; // ishonchli variant
    
    }
  }, []);

  const [chat_id, setChatId] = useState(null);

  useEffect(() => {
   
    const params = new URLSearchParams(window.location.search);
    let v = params.get("chat_id");
    setChatId(v);
  }, []);


  // useEffect(() => {
  //   setValue('email', '', { shouldDirty: true, shouldValidate: true });
  //   setValue('password', '', { shouldDirty: true, shouldValidate: true });
  // }, [setValue]);

  function onSubmit({ email, password }) {
    jwtService
      .signInWithEmailAndPassword(email, password, '', chat_id)
      .then((user) => {
        // No need to do anything, user data will be set at app/auth/AuthContext

        if (user.response.status == 401) {
          setValue('password', '');
          dispatch(showMessage({ message: `${t("IncorrectUsernameOrPassword")}`, variant: 'error', }));

        }

      });
  }

  const handleRegister = async () => {

    axios.post(`/v1/auth/register-user`, data).then(response => {
      dispatch(showMessage({ message: `${data.mail_address} yaratildi.`, variant: 'success' }));
    }).catch(error => {
      dispatch(showMessage({ message: error.response.data.message, variant: 'error', status: error.response.data.status, url: error.response.request.responseURL }));
    });

  };

  const handleChangeLogin = async () => {
    axios.post(`/user/forget-password?login=${changeUser}`).then(response => {
      dispatch(showMessage({ message: `${changeUser} ${t("SendEmail")}.`, variant: 'success' }));
    }).catch(error => {
      dispatch(showMessage({ message: error.response.data.message, variant: 'error', status: error.response.data.status, url: error.response.request.responseURL }));
    });
    setChangeUser('');
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({
      ...data,
      [name]: value
    });
  };



  return (
    <>
      {(decodedData.n && isMobile) ? 
        <PinCodeScreen props={{ info, chat_id }} /> :
        <div className="m-auto">

          <div className="h-full sm:h-auto md:block md:m-auto  w-full   sm:rounded-2xl md:rounded-none ">
            <Paper className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0 p-8 sm:p-24">
              <img className="w-3/4 m-auto" src="assets/images/logo/logo.png" alt="logo" />

              {/* <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight">
          {t("SignIn")}
          </Typography> */}
              {(!registryLogin) ?
                <>
                  {(changelogin == false) ?
                    <form
                      name="loginForm"
                      noValidate
                      className="flex flex-col justify-center w-full mt-32"
                      onSubmit={handleSubmit(onSubmit)}
                    >

                      <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            className="mb-24"
                            label={t('UserName')}
                            autoFocus


                            variant="outlined"
                            required
                            fullWidth
                          />
                        )}
                      />

                      <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            className="mb-24"
                            label={t('Password')}
                            type={showPassword ? "text" : "password"}
                            error={!!errors.password}
                            helperText={errors?.password?.message}
                            variant="outlined"
                            required
                            fullWidth
                            InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                               onClick={handleTogglePassword} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                          />
                        )}
                      />
                      <div onClick={(e) => { setChangeLogin(true) }} className='cursor-pointer text-blue-500'>
                        {t("ForgotPassword")}
                      </div>

                      <div onClick={(e) => { setRegistryLogin(true) }} className='cursor-pointer mt-16 text-16 text-blue-800'>
                        {t("Yangi kompaniya ochish")}
                      </div>


                      <Button
                        variant="contained"
                        color="secondary"
                        className=" w-full mt-16"
                        aria-label="Sign in"
                        disabled={_.isEmpty(dirtyFields) || !isValid}
                        type="submit"
                        size="large"
                      >
                        {t('SignIn')}
                      </Button>


                    </form> :

                    <div className="flex flex-col justify-center w-full mt-32">
                      <Typography color="secondary" className='text-14 mb-16 text-center'>{t("NewEmailPassword")}</Typography>
                      <TextField
                        className="mb-24"
                        label={t('UserName')}
                        autoFocus
                        variant="outlined"
                        required
                        fullWidth
                        onChange={(e) => {
                          setChangeUser(e.target.value)
                        }}
                      />

                      <div onClick={(e) => { setChangeLogin(false) }} className='cursor-pointer text-blue-500'>
                        {t("Login")}
                      </div>

                      <Button
                        className='mt-12'
                        variant="contained"
                        color="secondary"
                        onClick={(e) => { handleChangeLogin(e) }}
                      >
                        {t('Send')}
                      </Button>




                    </div>

                  }
                </> :
                <>
                  <div className="flex flex-col justify-center w-full mt-32">
                    <Typography color="secondary" className='text-14 mb-16 text-center'>{t("Yangi kompaniyani ro'yxatdan o'tkazish ma'lumotlarni to'liq kiriting")}</Typography>

                    <TextField
                      label={t("Surname")}
                      name="first_name"
                      className='col-span-2'
                      value={data.first_name}
                      onChange={handleChange} />

                    <TextField
                      label={t("Name")}
                      name="last_name"
                      className='col-span-2 mt-16'
                      value={data.last_name}
                      onChange={handleChange}
                    />

                    <TextField
                      label={"Kompaniya nomi"}
                      name="company_name"
                      className='col-span-2 mt-16'
                      value={data.company_name}
                      onChange={handleChange}
                    />


                    <TextField
                      select
                      inputProps={{ style: { padding: "15px" } }}
                      fullWidth
                      placeholder={t('Region')}
                      className="flex-auto mt-16"
                      label={t("Region")}
                      onChange={(e) => setData({ ...data, city: e.target.value })}
                      defaultValue={data.city}
                    >
                      {regions?.map(n => (
                        <MenuItem value={n.id}>{n.name}</MenuItem>
                      ))}

                    </TextField>

                    <TextField
                      label={t("Phone")}
                      name="phone_number"
                      type='number'
                      className='col-span-2 mt-16'
                      value={data.phone_number}
                      onChange={handleChange}
                    />

                    <TextField
                      label={"Login (*Eslab qoling*)"}
                      name="mail_address"
                      type='email'
                      className='col-span-2 mt-16'
                      value={data.mail_address}
                      onChange={handleChange}
                    />

                    <TextField
                      label={t("Password")}
                      name="password"
                      className='col-span-2 mt-16'
                      value={data.password}
                      onChange={handleChange}
                    />


                    <div onClick={(e) => { setRegistryLogin(false) }} className='cursor-pointer text-blue-500 mt-8'>
                      {t("Login")}
                    </div>

                    <Button
                      className='mt-12'
                      variant="contained"
                      color="secondary"
                      onClick={(e) => { handleRegister(e) }}
                    >
                      {t('Send')}
                    </Button>
                  </div>

                </>}


            </Paper>
          </div>

        </div>}
    </>
  );
}

export default SignInPage;
